import React from 'react';

const HireHero = () => {
    // Logos ka placeholder data (Kyuki images nahi hain, maine text use kiya hai)
    const clients = [
        "/assets/hire-n/item1.svg", 
        "/assets/hire-n/item2.svg", 
        "/assets/hire-n/item3.svg",
        "/assets/hire-n/item4.svg", 
        "/assets/hire-n/item5.svg", 
        "/assets/hire-n/item6.svg",
        "/assets/hire-n/item7.svg", 
        "/assets/hire-n/item8.svg", 
        "/assets/hire-n/item9.svg",
        "/assets/hire-n/item10.svg", 
        "/assets/hire-n/item11.svg", 
        "/assets/hire-n/item12.svg"
    ];

    return (
        <section className="relative w-full py-16 lg:py-0 lg:h-[630px] flex items-center bg-[#000814] overflow-hidden">
            <div className="absolute inset-0 z-0">
                <img
                    src="/assets/what/item12.png"
                    alt="Abstract 3D Tunnel Background"
                    className="w-full h-full object-cover"
                />
                <div style={{ background: "linear-gradient(90deg, #000000 10%, rgba(0, 0, 0, 0.6) 50%, rgba(0,0,0,0.2) 100%)" }} className="absolute inset-0"></div>
            </div>

            <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] grid grid-cols-1 lg:grid-cols-2 gap-12 items-center h-full">

                <div className="mt-10 lg:mt-0 max-w-[483px]">
                    <h1 className="text-white font-[600] text-[30px] lg:text-[40px] leading-[1.15] mb-6 drop-shadow-xl tracking-wide text-left">
                        Trusted by Startups and Leading Companies Worldwide
                    </h1>
                    <p className="text-[#E2E8F0] text-[14px] lg:text-[16px] leading-[28px] font-graphik font-light tracking-wide text-left opacity-90 max-w-[500px]">
                        We are proud to partner with organizations across industries,
                        delivering reliable engineering talent and long-term value.
                    </p>
                </div>

                {/* --- RIGHT SIDE: LOGO GRID (Glass Effect) --- */}
                <div className="w-full">
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:gap-x-[60px] gap-x-[20px] gap-y-[20px]">
                        {clients.map((client, index) => (
                            <div
                                key={index}
                            >
                               <img src={client} alt={index} />
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </section>
    );
};

export default HireHero;